module.exports = __webpack_public_path__ + "static/img/mAboutBg.e6a7765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/mAboutBg.jpg
// module id = j05r
// module chunks = 0